import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import Modal from "../lib/components/Modal";
import {ProfileItemCompForList} from "./ProfileItemCompForList";
import {IProileComp, IProfileCompData} from "../../interfaces/layout/blocks/IUser";
import {ReInit} from "./EditItemComp";

interface IFamilyCompProps {

}

interface IFamilyCompState extends IProfileCompData{
	sort:string;
	sortField: string;
	filter: string;
	familyFilter: string;
}

class FamilyComp extends React.Component<IFamilyCompProps, IFamilyCompState>{

    constructor(props:IFamilyCompProps){
        super(props);
        this.state = this.getInitState();
        this.getData();
    }

    protected getInitState():IFamilyCompState{
        return {
            live: [],
            death: [],
			sort: 'ASC',
			filter: '',
			sortField: 'name',
			familyFilter: 'full'
        } as IFamilyCompState;
    }

    protected getData():void{
        $.ajax({
            data:{
				sortField: this.state.sortField,
				sort: this.state.sort
            },
            type:               "POST",
            url:                "/user/getFamily" ,
            contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
            success: (data:IProfileCompData) => {
                this.setState({
                    live: data.live,
                    death: data.death
                } as IFamilyCompState);
            }
        });
    }

    private profileClickHandler(evt, id:number):void {
        evt.preventDefault();
        // tslint:disable-next-line:no-unused-expression
        new ReInit(id, ()=>{
            this.getData();
        });
    }

	private changeSortClickHandler(evt, sortField:string): void {
		evt.preventDefault();
		var newSort:string = 'ASC';
		if ( this.state.sortField === sortField ) {
			if ( this.state.sort === 'ASC') {
			    newSort = 'DESC';
			}
			this.setState({
				sort: newSort
			} as IFamilyCompState, ()=>{
                this.getData();
            });
		}else{
			this.setState({
				sortField: sortField,
				sort: 'ASC'
			} as IFamilyCompState, ()=>{
                this.getData();
            });
		}

	}

    private filterArray(arr:Array<IProileComp>):Array<IProileComp>{
        var filter:string = this.state.filter.toLowerCase().trim();
		var ret:Array<IProileComp> = [];
        if ( filter === '' ) {
            ret = arr;
        }else{
			for (var key in arr) {
	            var item = arr[key];
	            if ( item.name.toLowerCase().indexOf(filter) > -1 || item.birthName.toLowerCase().indexOf(filter) > -1 || item.birthDate.toLowerCase().indexOf(filter) > -1 || item.affinity.toLowerCase().indexOf(filter) > -1 || item.city.toLowerCase().indexOf(filter) > -1 ) {
	                ret.push(item);
	            }
	        }
		}

		return ret;
    }

	private sortByTag(arr:Array<IProileComp>, affinityGroup:number):Array<IProileComp>{
		var ret:Array<IProileComp> = [];
		for (var key in arr) {
		    var item = arr[key];
			if ( affinityGroup !== item.affinityGroup ) {
				continue;
			}
			if ( item.couplesIds.length > 0 ) {

				for (var ckey in item.couplesIds) {
				    var coupleId = item.couplesIds[ckey];
					//find and add
					for (var tkey in arr) {
					    var temp = arr[tkey];
						if ( temp.id === coupleId ) {
							if ( ret.indexOf(temp) === -1 ) {
								if ( ret.indexOf(item) === -1 ) {
									item.coupleAfter = true;
									item.coupleBefore = false;
									ret.push(item);
								}
								temp.coupleBefore = true;
								temp.coupleAfter = false;
								ret.push(temp);
							}
							break;
						}
					}
				}
				if ( ret.indexOf(item) === -1 ) {
					ret.push(item);
				}
			}else{
				if ( ret.indexOf(item) === -1 ) {
					ret.push(item);
				}
			}

		}
		var finalRet:Array<IProileComp> = [];
		for (var ikey in ret) {
			var user = ret[ikey];
			if ( user.coupleAfter !== undefined && user.coupleAfter === true ) {
                var index:number = parseInt(ikey) +1 ;
                if ( index % 3 === 0 ) {
					finalRet.push(null);
                }
            }
			finalRet.push(user);
		}
        return finalRet;
	}

    private filterChangeHandler(evt): void {
        evt.preventDefault();
        this.setState({
            filter: evt.target.value.toString()
        } as IFamilyCompState);
    }

    render() {
        var live = this.filterArray(this.state.live);
        var death = this.filterArray(this.state.death);
        return (
            <div className="family" id="family_comp">
                <div className="header">
                    <ul className="search">
                        <li>
                            <input type="text" placeholder="Szűrés" value={ this.state.filter } onChange={ e => this.filterChangeHandler(e) } />
                        </li>
                    </ul>
                    <ul className="sort">
                        <li>
                            <a onClick={ e => this.changeSortClickHandler(e, 'birthDate') } className={
								this.state.sortField==='birthDate' ? 'active' : ''
							}>Születés szerint</a>
                        </li>
                        <li>
						<a onClick={ e => this.changeSortClickHandler(e, 'name') } className={
							this.state.sortField==='name' ? 'active' : ''
						}>ABC sorrendben</a>
                        </li>
                        <li>
                            <a onClick={ e => this.changeSortClickHandler(e, 'name') } className={
								this.state.sortField==='nameX' ? 'active' : ''
							}>Rokonsági fok</a>
                        </li>
                    </ul>
                </div>
                <div className="body live affinity_group_0">
                    { this.sortByTag(live, 0).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'l_affinity_group_0_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter }  onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'l_affinity_group_0_'+index }></div>
						}
                    })}
                </div>
				<div className="body live affinity_group_1">
                    { this.sortByTag(live, 1).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'l_affinity_group_1_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter } onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'l_affinity_group_1_'+index }></div>
						}
                    })}
                </div>
				<div className="body live affinity_group_2">
                    { this.sortByTag(live, 2).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'l_affinity_group_2_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter } onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'l_affinity_group_2_'+index }></div>
						}
                    })}
                </div>
				<div className="body live affinity_group_null">
                    { this.sortByTag(live, null).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'l_affinity_group_null_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter } onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'l_affinity_group_null_'+index }></div>
						}
                    })}
                </div>

				<div className="body death affinity_group_0">
                    { this.sortByTag(death, 0).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'affinity_group_0_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter }  onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'affinity_group_0_'+index }></div>
						}
                    })}
                </div>
				<div className="body death affinity_group_1">
                    { this.sortByTag(death, 1).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'affinity_group_1_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter } onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'affinity_group_1_'+index }></div>
						}
                    })}
                </div>
				<div className="body death affinity_group_2">
                    { this.sortByTag(death, 2).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'affinity_group_2_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter } onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'affinity_group_2_'+index }></div>
						}
                    })}
                </div>
				<div className="body death affinity_group_null">
                    { this.sortByTag(death, null).map((item:IProileComp, index:number) => {
						if ( item !== null ) {
								return <ProfileItemCompForList listMode={true} id={ item.id } key={ 'affinity_group_null_'+index } name={ item.name } birthName={ item.birthName } birthDate={ item.birthDate } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } coupleBefore={ item.coupleBefore } coupleAfter={ item.coupleAfter } onClick={ (e, id) => this.profileClickHandler(e, id) } />
						}else{
							return <div className="break" key={ 'affinity_group_null_'+index }></div>
						}
                    })}
                </div>
            </div>
        );
    }
}
export default class InitFamilyComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('family_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.render(< FamilyComp/>, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/FamilyComp.tsx